import React from 'react';
import { StructuredText } from 'react-datocms';
import ControlledVideo from '../ControlledVideo';
import PlaySoundButton from '../PlaySoundButton';

/**
 * Renders a single DatoCMS block (video, image, audio, tinymce, gallery).
 */
export function renderStructuredBlock({ record }) {
  switch (record.__typename) {
    case 'DatoCmsVideo':
      return (
        <ControlledVideo
          style={{ maxWidth: 500, margin: '2.5rem auto' }}
          url={record.video?.url}
          autoPlay
          muted
        />
      );
    case 'DatoCmsImageBlock':
      return (
        <img
          style={{
            maxWidth: '100%',
            margin: '1em auto',
            display: 'block',
          }}
          src={record.image?.url}
          alt={record.image?.alt || ''}
        />
      );
    case 'DatoCmsAudioPlayer':
      return (
        <PlaySoundButton
          className="my-1"
          label={record.title || 'Play Audio'}
          soundUrl={record?.audioUrl ?? record.audio?.url}
        />
      );
    case 'DatoCmsTinymce':
      return (
        <div dangerouslySetInnerHTML={{ __html: record.body }} />
      );
    case 'DatoCmsImageGallery':
      return (
        <div>
          <div
            className="image-gallery-block"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${record.columns || 3}, 1fr)`,
              gap: '10px',
              maxWidth: '800px',
              margin: '2em auto',
            }}
          >
            {(record.images || []).map((img, idx) => (
              <img
                key={idx}
                src={img.url}
                alt={img.alt || `Gallery image ${idx + 1}`}
                style={{ width: '100%', height: 'auto' }}
              />
            ))}
          </div>
        </div>
      );
    default:
      return null;
  }
}

/**
 * Transform body blocks to use originalId as id for StructuredText.
 */
export function transformContentBody(body) {
  if (!body?.blocks) return body;
  return {
    ...body,
    blocks: body.blocks.map((block) => ({
      ...block,
      id: block.originalId,
    })),
  };
}
